import PropTypes from "prop-types";
import React from "react";
import { DragDropContext } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import HTML5 from "react-dnd-html5-backend";
import TouchBackend from "react-dnd-touch-backend";
import { connect } from "react-redux";
import {
  addPlaylistItem,
  addUserReport,
  confirmationRequest,
  deletePlaylistItem,
  fetchPlaylists,
  setPageTitle,
  updatePlaylist,
  updatePlaylistItem,
  bulkUpdateRequest,
  updateAsset,
  fetchPlaylistRequest,
  fetchPlaylistDetail,
} from "../../actions";
import { PLAYLIST_ITEMS_RESOURCE } from "../../api/resources";
import { AssetDND, EditableLabel, Page, PlaylistView } from "../../components";
import Box from "../../components/layout/Box";
import PlaylistPreviewLink from "../../components/PlaylistPreviewLink";
import { Button, Loading } from "../../components/widgets";
import {
  fixPlaylistPositions,
  getProfile,
  updatePlaylistPositions,
  isFetchingPlaylist,
  isFetching,
  getConfirmationState,
  getbulkUpdatePlaylists,
  getDetailPlaylist,
  getLoadingPlaylistDetail,
  getPlaylistV2
} from "../../selectors";
import "./styles.scss";
import Dropdown, {
  DropdownContent,
  DropdownTrigger,
} from "react-simple-dropdown";
import { API_ROOT } from "signoxe/constants/config";

class PlaylistPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      adding: false,
      bulkEditing: false,
      isCampaignClicked: false,
      campaignAssets: [],
      selection: [],
      selected: false,
      showPopup: false,
      showThumbnails: false,
      sortState: "none",
      ItemType: null,
      filterOptions: false,
      replacing: false,
      reportActivityStatus:
        this.props.profile &&
        this.props.profile.features &&
        this.props.profile.features.record_user_activity,
      editPostion: false,
      playlist: null,
      isDeleting: false,
      itemId: null,
    };
  }

  static propTypes = {
    profile: PropTypes.array.isRequired,
    fetchPlaylists: PropTypes.func.isRequired,
    fetchPlaylistDetail: PropTypes.func.isRequired,
    updatePlaylist: PropTypes.func.isRequired,
    updatePlaylistItem: PropTypes.func.isRequired,
    addPlaylistItem: PropTypes.func.isRequired,
    addUserReport: PropTypes.func.isRequired,
    deletePlaylistItem: PropTypes.func.isRequired,
    confirmationRequest: PropTypes.func.isRequired,
    playlistDetail: PropTypes.func.isRequired,
    setPageTitle: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    playlist: PropTypes.object,
    bulkUpdateRequest: PropTypes.func.isRequired,
    isFetching: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
  };

  handleAddItem = () => this.setState({ adding: true });

  handleSelectAll = () => {
    this.setState({ selected: !this.state.selected });
    // const selection = {};
    // this.props.playlist.items.forEach((asset) => (selection[asset.id] = true));
    // this.setState({ selection });
  };

  handleAssetAdd = (assetId) => {
    this.props.addPlaylistItem({
      playlist: this.props.playlist.id,
      item: assetId,
      position: -1,
    });
    this.props.fetchPlaylistDetail(this.props.match.params.id);
  };

  handleUserReport = (message) => {
    const { profile } = this.props;
    if (this.state.reportActivityStatus) {
      this.props.addUserReport({
        user: profile.id,
        action_type: "Update",
        activity: message + "playlist - " + this.props.playlist.name,
      });
    }
  };

  handleAssetBrowserClose = () => this.setState({ adding: false });

  getFields = (input, field) => {
    var output = [];
    for (var i = 0; i < input.length; ++i) output.push(input[i][field]);
    return output;
  };

  handleAssetBulkAdd = (assets) => {
    // console.log("camapign selected assets = ", assets);
    {
      this.state.reportActivityStatus &&
        this.handleUserReport(`Added assests with id - ${assets} to `);
    }
    assets.forEach((assetId) => this.handleAssetAdd(assetId));
    this.props.fetchPlaylistDetail(this.props.match.params.id);
  };

  handleAssetDrop = (asset) => {
    if (asset.hasOwnProperty("asset")) {
      let assets = asset.asset;
      var fetchAssests = this.getFields(assets, "name");
      // console.log("camapign droped assets = ", fetchAssests);
      assets.forEach((campaignAsset) => this.handleAssetDrop(campaignAsset));
    } else {
      // console.log("single dropped asset = ", asset);
      this.handleAssetAdd(asset.id);
      {
        this.state.reportActivityStatus &&
          this.handleUserReport(`Added ${asset.name} to `);
      }
      this.setState({ adding: false });
    }
    // this.props.fetchPlaylistDetail(this.props.match.params.id);
    //console.log("handleAssetDrop asset = ", asset);
  };

  handleBulkDeletePlaylistItems = (items) => {
    items.forEach((item) => this.props.deletePlaylistItem(item.id));
    this.setState({ isDeleting: true });
  };

  handleDeletePlaylistItem = (item) => {
    const { profile, playlist } = this.props;
    if (this.state.reportActivityStatus) {
      this.props.addUserReport({
        user: profile.id,
        action_type: "Delete",
        activity: `deleted (or attempt to delete)  ${item.item.name} in playlist - ${this.props.playlist.name}`,
      });
    }

    this.props.confirmationRequest(
      "Deleting Playlist Item",
      `Are you sure you want to remove "${item.item.name}" from this playlist?`,
      "DELETE",
      PLAYLIST_ITEMS_RESOURCE,
      item.id
    );
  };

  handlePlaylistReorder = (playlist) => {
    this.props.updatePlaylist(playlist.id, updatePlaylistPositions(playlist));
  };

  handlePlaylistReposition = (playlist) => {
    this.props.updatePlaylist(playlist.id, fixPlaylistPositions(playlist));
    this.setState({ editPostion: false });
  };

  handleRename = (newName) => {
    this.props.updatePlaylist(this.props.playlist.id, { name: newName });
  };

  handleSubscriptionChangse = (e) => {
    this.props.updatePlaylist(this.props.playlist.id, {
      auto_add_feeds: e.currentTarget.checked,
    });
  };

  handleToggleReorder = () => {
    this.setState({ bulkEditing: !this.state.bulkEditing });
    this.setState({ showPopup: false });
  };
  handleEditPostions = () => {
    this.setState({ editPostion: !this.state.editPostion });
    this.setState({ showPopup: false });
  };

  handleSelectionON = (newSelected) => {
    this.setState({ selection: newSelected });
    if (newSelected.length == 0) {
      this.setState({ showPopup: false });
    } else {
      this.setState({ showPopup: true });
    }
  };

  deleteAllSelected = () => {
    var arrayStr = this.state.selection.map(function (x) {
      return x.replace("select-", "");
    });

    var arrToNum = arrayStr.map((str) => {
      return Number(str);
    });

    let new_arrray = this.props.playlist.items;
    var newr = new_arrray.filter((e) => !arrToNum.find((num) => e.id === num));

    // this.handleBulkDeletePlaylists(arrToNum)

    this.props.bulkUpdateRequest(
      `Bulk Deleting of ${this.props.playlist.title} Item(s)`,
      `Confirm deleting of "${arrToNum.length}" items(s), cannot be undone.`,
      "DELETE",
      PLAYLIST_ITEMS_RESOURCE,
      arrToNum.length,
      arrToNum
    );

    // arrToNum.forEach((item) => this.props.deletePlaylistItem(item));

    this.setState({ isDeleting: true });

    this.setState({ showPopup: false });
    // this.setState({ bulkEditing: false })
    this.setState({ selection: [] });
  };

  handleUpdatePlaylistItem = (item) => {
    this.props.updatePlaylistItem(item.id, item);
    // this.props.fetchPlaylistDetail(this.props.match.params.id);
  };

  componentDidMount() {
    // this.props.fetchPlaylists();
    this.props.setPageTitle("Playlist");
    this.props.fetchPlaylistDetail(this.props.match.params.id);
  }

  handleCampaignClick = (campaign) => {
    this.setState({ campaignAssets: campaign.assets, isCampaignClicked: true });
    console.log("handleCampaignClick() assets = ", campaign);
  };

  handleGoBack = (campaign) => {
    this.setState({ isCampaignClicked: false });
  };

  resetViews = () => {
    this.setState({ showPopup: false });
    this.setState({ selection: [] });
  };

  onAssetChange = (newAsset) => {
    this.props.updateAsset(newAsset.id, { name: newAsset.name });
  };

  handleshowThumbnails = () => {
    this.setState({ showThumbnails: !this.state.showThumbnails });
  };
  handleSwitchItemType = (ItemType) => {
    if (ItemType == "null") {
      this.setState({ itemType: null });
    } else {
      this.setState({ itemType: ItemType });
    }
  };

  handleSortType = (sortBy) => {
    this.setState({ sortState: sortBy });
  };

  handleToggleFilters = () => {
    this.setState({ filterOptions: !this.state.filterOptions });
  };

  refreshPage = () => {
    window.location.reload(false);
  };

  handleSelectionReplace = (assets) => {
    console.log("assets", assets[0]);

    // get the assest

    // getting the items to be replaced
    var arrayStr = this.state.selection.map(function (x) {
      return x.replace("select-", "");
    });

    var arrToNum = arrayStr.map((str) => {
      return Number(str);
    });

    let new_arrray = this.props.playlist.items;
    var newr = new_arrray.filter((e) => arrToNum.find((num) => e.id === num));
    console.log("newaray", newr);

    // update items to replace with the assset
    newr.forEach((t) => {
      this.props.updatePlaylistItem(t.id, { item: assets[0] });
    });

    this.setState({ replacing: false });
    this.setState({ bulkEditing: false });
    this.refreshPage();
  };

  handleToggleReplacing = () => {
    this.setState({ replacing: !this.state.replacing });
  };

  render() {
    const { isFetching, playlist, loading, playlistdetail } = this.props;
    const { showPopup, selection, isDeleting } = this.state;
    const is_maker_checker =
      this.props.profile && this.props.profile.maker_checker;
    const { visible } = this.props.confirmationState;

    const isTimedPlayback =
      this.props.profile && this.props.profile.timed_playback;

    console.log("playlistdetail", playlistdetail);


    if (!playlist) {
      return <Loading />;
    }
    console.log("playlist props = ", playlist);

    return (
      <Page className="playlist-page">
        <React.Fragment>
          {showPopup && (
            <div id="note">
              <div>
                <h6>
                  {selection && selection.length}
                  {selection.length > 1 ? " Items Selected" : " Item Selected"}
                </h6>
              </div>
              <div className="btns">
                {/* <button className='btn1' onClick={this.resetViews} > <i className='fas fa-eye-slash'></i> RESET VIEWS</button> */}
                <button className="btn1" onClick={this.handleToggleReplacing}>
                  {" "}
                  <i className="fas fa-exchange"></i> REPLACE
                </button>
                <button className="btn2" onClick={this.deleteAllSelected}>
                  {" "}
                  <i className="fas fa-trash"></i> DELETE
                </button>
              </div>
            </div>
          )}
          <div style={{ marginTop: "1rem", marginBottom: "1.8rem" }}>
            <Box
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              className="actions"
            >
              <h3>
                {playlistdetail && (
                  <EditableLabel
                    value={playlistdetail.name}
                    onChange={this.handleRename}
                  />
                )}
              </h3>
              <div className="hide-for-mobile">
                <Button onClick={this.handleAddItem}>Add Item</Button>
                <Button onClick={this.handleToggleReorder}>
                  {this.state.bulkEditing ? "Cancel" : "Bulk Edit"}
                </Button>
                <Button onClick={this.handleEditPostions}>
                  {this.state.editPostion ? "Cancel" : "Edit Postions"}
                </Button>

                <PlaylistPreviewLink
                  playlist={playlist.id}
                  label="Preview in Browser"
                />
              </div>

              <div className="hide-for-desktop">
                {this.state.adding === false && (
                  <div className="flex ai-i-c">
                    {this.state.bulkEditing == false ? (
                      <Dropdown>
                        <DropdownTrigger>
                          <button type="button" className="button">
                            <span
                              style={{ marginRight: "5px", fontSize: "0.8rem" }}
                            >
                              Actions
                            </span>
                            <span
                              title="actions"
                              className="icon fa fa-caret-down"
                              style={{ fontSize: "1rem", color: "#fff" }}
                            ></span>
                          </button>
                        </DropdownTrigger>
                        <DropdownContent className="user-menu actions-menu card depth-1">
                          <li onClick={this.handleAddItem}>Add Item</li>
                          <li onClick={this.handleToggleReorder}>
                            {this.state.bulkEditing ? "Cancel" : "Bulk Edit"}
                          </li>
                          <li onClick={this.handleEditPostions}>
                            {this.state.editPostion
                              ? "Cancel"
                              : "Edit Postions"}
                          </li>

                          <li onClick={this.handleshowThumbnails}>
                            <i
                              className={
                                this.state.showThumbnails
                                  ? "fas fa-toggle-on mr-1"
                                  : "fas fa-toggle-off mr-1"
                              }
                            ></i>
                            Show Thumbnails
                          </li>
                          <li onClick={this.handleSubscriptionChange}>
                            <input
                              style={{ "margin-right": "1rem" }}
                              type="checkbox"
                              onChange={this.handleSubscriptionChange}
                              defaultValue={playlist.auto_add_feeds}
                            />
                            Subscribe
                          </li>
                        </DropdownContent>
                      </Dropdown>
                    ) : (
                      <Button onClick={this.handleToggleReorder}>
                        {this.state.bulkEditing ? "Cancel" : "Bulk Edit"}
                      </Button>
                    )}
                  </div>
                )}
              </div>
            </Box>
          </div>
          <div></div>

          {loading && (
            <div className="loader-center flex flex-dc mt-1">
              <div class="loader"></div>
              <small>Loading content</small>
            </div>
          )}

          {!loading && (
            <Box direction="row" className="split-content">
              <PlaylistView
                playlist={playlist}
                handleSelectedReplace={this.handleSelectedReplace}
                selectAll={this.state.selected}
                editing={this.state.bulkEditing}
                handleAddItem={this.handleAddItem}
                adding={this.state.adding}
                replacing={this.state.replacing}
                handleToggleReorder={this.handleToggleReorder}
                onDrop={this.handleAssetDrop}
                selection={this.state.selection}
                handleSubscriptionChange={this.handleSubscriptionChange}
                bulkEdit={this.state.bulkEditing}
                onReorder={this.handlePlaylistReorder}
                onReposition={this.handlePlaylistReposition}
                onDeletePlaylistItem={this.handleDeletePlaylistItem}
                onBulkDeletePlaylistItems={this.handleBulkDeletePlaylistItems}
                onUpdatePlaylistItem={this.handleUpdatePlaylistItem}
                onSelectionON={this.handleSelectionON}
                onAssetChange={this.onAssetChange}
                showThumbnails={this.handleshowThumbnails}
                showThumbnailsState={this.state.showThumbnails}
                itemType={this.state.itemType}
                sortState={this.state.sortState}
                handleSwitchItemType={this.handleSwitchItemType}
                handleSortType={this.handleSortType}
                filterOptionsEnabled={this.state.filterOptions}
                editPostion={this.state.editPostion}
                handleUserReport={this.handleUserReport}
                reportActivityStatus={this.state.reportActivityStatus}
                isTimedPlayback={isTimedPlayback}
              />

              {this.state.adding ? (
                <AssetDND
                  onClose={this.handleAssetBrowserClose}
                  onCampaignClick={this.handleCampaignClick}
                  onBulkAddAssets={this.handleAssetBulkAdd}
                  isCampaignClicked={this.state.isCampaignClicked}
                  campaignAssets={this.state.campaignAssets}
                  onBack={this.handleGoBack}
                  replacing={false}
                  is_maker_checker={is_maker_checker}
                />
              ) : null}

              {this.state.replacing ? (
                <AssetDND
                  onClose={this.handleAssetBrowserClose}
                  onCampaignClick={this.handleCampaignClick}
                  replaceAddItems={this.handleSelectionReplace}
                  isCampaignClicked={this.state.isCampaignClicked}
                  campaignAssets={this.state.campaignAssets}
                  onBack={this.handleGoBack}
                  replacing={true}
                  is_maker_checker={is_maker_checker}
                />
              ) : null}
            </Box>
          )}
        </React.Fragment>
      </Page>
    );
  }
}

let backend = HTML5Backend;

if (window.innerWidth <= "600") {
  backend = TouchBackend;
}

console.log("Backend is ", backend);

export default connect(
  (state, { match }) => ({
    profile: getProfile(state),
    isFetching: isFetchingPlaylist(state),
    confirmationState: getConfirmationState(state),
    bulkConfirmationState: getbulkUpdatePlaylists(state),
    playlist: getDetailPlaylist(state),
    loading: getLoadingPlaylistDetail(state),
    playlistdetail: getPlaylistV2(state, parseInt(match.params.id, 10)),
  }),

  {
    fetchPlaylists,
    updatePlaylist,
    confirmationRequest,
    updatePlaylistItem,
    addPlaylistItem,
    addUserReport,
    setPageTitle,
    deletePlaylistItem,
    bulkUpdateRequest,
    updateAsset,
    fetchPlaylistRequest,
    fetchPlaylistDetail,
  }
)(PlaylistPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/PlaylistPage/index.js